import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

/**
 * Modal confirmación delete batch (soft-delete).
 * Props: open, onClose, count, onConfirm, loading
 */
const BatchConfirmDeleteDialog = ({ open, onClose, count = 0, onConfirm, loading = false }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("batchDeleteDialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {i18n.t("batchDeleteDialog.body", { count })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {i18n.t("batchDeleteDialog.cancel")}
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#f44336", color: "#fff" }}
          onClick={onConfirm}
          disabled={loading}
        >
          {i18n.t("batchDeleteDialog.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BatchConfirmDeleteDialog;
